import BlankErrorBoundary from 'components/BlankErrorBoundary';
import React, { Suspense, lazy } from 'react';
import { ConnectedCameraDeviceWrapper } from './Utilities';

// Lazy-load the component
const BarcodeScanner = lazy(() => import('./BarcodeScanner'));

const BarcodeScannerWrapper = (props) => {
    return (
        <ConnectedCameraDeviceWrapper>
            {({ deviceId, safeToStart }) => (
                <BlankErrorBoundary>
                    <Suspense fallback={''}>
                        <BarcodeScanner
                            components={{ audio: false }}
                            constraints={deviceId ? { deviceId, focusMode: 'continuous' } : { focusMode: 'continuous', facingMode: 'environment' }}
                            safeToStart={safeToStart}
                            {...props}
                        />
                    </Suspense>
                </BlankErrorBoundary>
            )}
        </ConnectedCameraDeviceWrapper>
    );
};

export default BarcodeScannerWrapper;